/**
 * ZIP+4 policy for USPS-normalized addresses (BACKLOG-1292).
 *
 * Current practice is to STRIP the +4 (Bill 2026-09-17; the legacy SPFx app
 * defaulted `stripZipPlus4` to true, "Risk Mgmt policy — discontinued +4").
 * Admins turn stripping off with SystemSettings `address.stripZipPlus4` = false
 * (Admin Panel → System → Settings) without a deploy.
 *
 * Every place that takes a ZIP from a USPS result formats it here: the person
 * dialog's address section, the photo-ID scan and the address-change action.
 * ConfigContext registers the live setting on load; until then the default
 * (strip) applies.
 */

let registered: unknown;

/** Called by ConfigContext whenever the system-settings bundle loads. */
export function registerZipPlus4Setting(systemSettings: Record<string, unknown> | undefined): void {
  registered = systemSettings?.['address.stripZipPlus4'];
}

/** True unless the setting explicitly turns stripping off (boolean, string or number). */
export function stripZipPlus4Enabled(raw: unknown = registered): boolean {
  return !(raw === false || raw === 'false' || raw === 'False' || raw === 0 || raw === '0');
}

/** The ZIP to store from a USPS result: ZIP5, or ZIP5-ZIP4 only when stripping is off. */
export function uspsZip(zip5: string | undefined, zip4: string | undefined, strip: boolean = stripZipPlus4Enabled()): string {
  if (!zip5) return '';
  return !strip && zip4 ? `${zip5}-${zip4}` : zip5;
}
